// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__17bp1","row":"ProcedureTreatmentSummary_row__3hmKx"};